import { markRaw } from 'vue'
import { Registerable } from '@baserow/modules/core/registry'
import GeneralSettingsComponent from '@baserow/modules/builder/components/settings/GeneralSettings'
import IntegrationSettingsComponent from '@baserow/modules/builder/components/settings/IntegrationSettings'
import ThemeSettingsComponent from '@baserow/modules/builder/components/settings/ThemeSettings'
import DomainsSettingsComponent from '@baserow/modules/builder/components/settings/DomainsSettings'
import UserSourcesSettingsComponent from '@baserow/modules/builder/components/settings/UserSourcesSettings'
import BreakpointsSettingsComponent from '@baserow/modules/builder/components/settings/BreakpointsSettings'

const GeneralSettings = markRaw(GeneralSettingsComponent)
const IntegrationSettings = markRaw(IntegrationSettingsComponent)
const ThemeSettings = markRaw(ThemeSettingsComponent)
const DomainsSettings = markRaw(DomainsSettingsComponent)
const UserSourcesSettings = markRaw(UserSourcesSettingsComponent)
const BreakpointsSettings = markRaw(BreakpointsSettingsComponent)

export class BuilderSettingType extends Registerable {
  static getType() {
    return null
  }

  get name() {
    return null
  }

  get icon() {
    return null
  }

  get component() {
    return null
  }

  get componentPadding() {
    return true
  }

  isDeactivated({ workspace }) {
    return !!this.isDeactivatedReason({ workspace })
  }

  isDeactivatedReason({ workspace }) {
    return null
  }

  getDeactivatedModal({ workspace }) {
    return null
  }
}

export class GeneralBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'general'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.generalName')
  }

  get icon() {
    return 'iconoir-settings'
  }

  getOrder() {
    return 1
  }

  get component() {
    return GeneralSettings
  }
}

export class BreakpointsBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'breakpoints'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.breakpointsName')
  }

  get icon() {
    return 'iconoir-move-ruler'
  }

  getOrder() {
    return 30
  }

  get component() {
    return BreakpointsSettings
  }
}

export class IntegrationsBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'integrations'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.integrationsName')
  }

  get icon() {
    return 'iconoir-ev-plug'
  }

  getOrder() {
    return 10
  }

  get component() {
    return IntegrationSettings
  }
}

export class ThemeBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'theme'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.themeName')
  }

  get icon() {
    return 'iconoir-fill-color'
  }

  getOrder() {
    return 20
  }

  get component() {
    return ThemeSettings
  }
}

export class DomainsBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'domains'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.domainsName')
  }

  get icon() {
    return 'iconoir-globe'
  }

  getOrder() {
    return 5
  }

  get component() {
    return DomainsSettings
  }
}

export class UserSourcesBuilderSettingsType extends BuilderSettingType {
  static getType() {
    return 'user_sources'
  }

  get name() {
    return this.app.$i18n.t('builderSettingTypes.userSourcesName')
  }

  get icon() {
    return 'iconoir-community'
  }

  getOrder() {
    return 15
  }

  get component() {
    return UserSourcesSettings
  }
}
